import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chapterContent", "chapterChevron", "profileContent", "profileChevron"]

  connect() {
    // Set initial max-height and chevron rotation for expanded/collapsed chapters
    this.chapterContentTargets.forEach(content => {
      const chapterId = content.dataset.chapterId
      const chevron = this.chapterChevronTargets.find(el => el.dataset.chapterId === chapterId)

      if (!content.classList.contains('collapsed')) {
        // For initially expanded chapters, set to 'none' to allow nested expansion
        content.style.maxHeight = 'none'
        if (chevron) chevron.style.transform = 'rotate(180deg)'
      } else {
        if (chevron) chevron.style.transform = 'rotate(0deg)'
      }
    })

    // Initialize profile section as collapsed
    if (this.hasProfileContentTarget) {
      this.profileContentTarget.style.maxHeight = '0'
      if (this.hasProfileChevronTarget) {
        this.profileChevronTarget.style.transform = 'rotate(0deg)'
      }
    }
  }

  toggleChapter(event) {
    const chapterId = event.currentTarget.dataset.chapterId
    const content = this.chapterContentTargets.find(el => el.dataset.chapterId === chapterId)
    const chevron = this.chapterChevronTargets.find(el => el.dataset.chapterId === chapterId)

    if (content.classList.contains('collapsed')) {
      // Expand
      content.classList.remove('collapsed')
      content.style.maxHeight = content.scrollHeight + 'px'
      chevron.style.transform = 'rotate(180deg)'

      // After animation completes, set to 'none' to allow nested content to expand
      setTimeout(() => {
        if (!content.classList.contains('collapsed')) {
          content.style.maxHeight = 'none'
        }
      }, 300) // Match transition duration
    } else {
      // Collapse - first set explicit height for smooth animation
      content.style.maxHeight = content.scrollHeight + 'px'

      // Force reflow to ensure transition works
      content.offsetHeight

      // Then collapse
      content.classList.add('collapsed')
      content.style.maxHeight = '0'
      chevron.style.transform = 'rotate(0deg)'
    }
  }

  toggleProfile(event) {
    event.preventDefault()
    const content = this.profileContentTarget
    const chevron = this.profileChevronTarget
    const isCollapsed = content.style.maxHeight === '0px' || content.style.maxHeight === '0'

    if (isCollapsed) {
      // Expand
      content.style.maxHeight = content.scrollHeight + 'px'
      chevron.style.transform = 'rotate(180deg)'

      // After animation completes, set to 'none' to allow nested content to expand
      setTimeout(() => {
        if (content.style.maxHeight !== '0px' && content.style.maxHeight !== '0') {
          content.style.maxHeight = 'none'
        }
      }, 300) // Match transition duration
    } else {
      // Collapse - first set explicit height for smooth animation
      content.style.maxHeight = content.scrollHeight + 'px'

      // Force reflow
      content.offsetHeight

      // Then collapse
      content.style.maxHeight = '0'
      chevron.style.transform = 'rotate(0deg)'
    }
  }
}
